export default [
	{
		text: 'Version',
		value: 'version',
		order: 0,
		sortable: true,
		hidable: false,
		hidden: false,
	},
	{
		text: 'File Name',
		value: 'fileName',
		order: 1,
		sortable: true,
		hidable: true,
		hidden: false,
	},
	
	{
		text: 'Size',
		value: 'fileSize',
		order: 2,
		sortable: true,
		hidable: true,
		hidden: false,
	},
	{
		text: 'Release Notes',
		value: 'releaseNotes',
		order: 3,
		sortable: false,
		hidable: true,
		hidden: false,
	},
	
	
	{
		text: 'Uploaded',
		value: 'createdOn',
		order: 6,
		sortable: true,
		hidable: true,
		hidden: false,
	},
	{
		text: 'Latest',
		value: 'isLatest',
		order: 2,
		sortable: true,
		hidable: true,
		hidden: false,
		align: 'left',
		width: '150px',
	},
	{
		text: 'Active',
		value: 'isActive',
		order: 5,
		sortable: true,
		hidable: true,
		hidden: false,
		align: 'left',
		width: '160px',
	},
	{
		text: 'Actions',
		value: 'actions',
		align: 'right',
		sortable: false,
		order: 7,
		hidable: true,
		hidden: false,
		width: '92px',
	},
];
